/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import Panel from './Panel';
import ModalPagos from './ModalPagos';
import * as validations from '../../validations/validations';
import * as tipomonedaActions from '../../actions/tipomonedaActions';
import * as cursotipomonedaActions from '../../actions/cursotipomonedaActions';
import * as inscripcionActions from '../../actions/inscripcionActions';
import * as pagosActions from '../../actions/pagosActions';
import withRouter from '../common/withRouter';

import income from '../../data/income.json';
         
import {  useParams } from "react-router-dom";
import {  useLocation, useNavigate  } from "react-router-dom";

import * as paginaActions from '../../actions/paginaActions';
import * as cursoActions from '../../actions/cursoActions';
import * as usuarioActions from '../../actions/usuarioActions';
import * as userActions from '../../actions/userActions';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import { Segment} from 'semantic-ui-react';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment';
import {getMargenes, usuarioActual} from '../../util/';
import {exportCSVFile} from '../common/jsonTocsv';
import $ from 'jquery';
import dayjs from 'dayjs';

class ManageInscripcionForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            ventaInvMf:income,
            permisos:{},
            busqueda:"",
            showModalPagos:false,
            inscripcionLista:[],
            pagosLista:[],
            cursoMoneda:[],
            filtro:"",
			inscripcion:{
                    idEstatus:1,
                    idTipoPago:1,
                    noCuotas:1,
                    costoPagado:0,
                    fechaInicio: new moment().format('DD/MM/YYYY'),
                    costoCurso:0,
                    descuento:0
                    },
            usuario:{
                id:0
                
            },
            tipoPagoCombo:[
                {id:1, descripcion:"Transferencia"},
                {id:2, descripcion:"PayPal"}
            
            ],
            estatusCombo:[
                {id:1, descripcion:"Activo"},
                {id:2, descripcion:"En proceso de Autorización"},
                {id:9, descripcion:"Retrasado"},
                {id:8, descripcion:"Bloqueado"},
            
            ]
		};
		
	}
    
    
    componentDidMount(){
        
        let id=this.props.id;
        
        /*
        let pageInfo={ 
            page:'inscripcion', 
            idioma:this.props.idioma     
        }; 
        this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);  
        this.props.paginaActions.getInfo(pageInfo, this.props.user).then( pageInfoResponse=>{ 
           this.setState({"permisos":pageInfoResponse.permisos, 
                         "strings":Object.assign({}, pageInfoResponse.strings)}); 
       }) 
        .catch(error=>{ 
          toastr.error(error); 
        });
        */
        
         usuarioActual(this, "inscripcion",true).then( (usuario)=>{
      
            let pageInfo={ 
                page:'inscripcion', 
                idioma:this.props.idioma     
            };
             
            this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);  
            this.props.paginaActions.getInfo(pageInfo, usuario).then( pageInfoResponse=>{ 
                    this.setState({"permisos":pageInfoResponse.permisos, 
                    "strings":Object.assign({}, pageInfoResponse.strings)}); 
            }) 
            .catch(error=>{ 
              toastr.error(error); 
            });
             
             
             
             
            if(id && id>0 ){

                this.props.inscripcionActions.getInscripcion(id, usuario).then( inscripcion=>{
                    this.setState({"inscripcion":inscripcion});
                })
                .catch(error=>{
                  toastr.error(error);
                });


            }
        
        
            this.props.usuarioActions.getUsuarioCombo(12, usuario).then( ()=>{ 

            }) 
            .catch(error=>{ 
              toastr.error(error); 
            });

            this.props.cursoActions.getCursoCombo(usuario).then(()=>{
            
            }) 
            .catch(error=>{ 
              toastr.error(error); 
            }); 

            this.props.tipomonedaActions.getTipoMonedaCombo(usuario).then(()=>{
                
            }) 
            .catch(error=>{ 
              toastr.error(error); 
            }); 

             
        }).catch(error=>{
          toastr.error(error);
        });  
		
    }
    
    fechas=(fechasArreglo, fechasCadena, id=0)=>{
       
        
        if(id>0){
            
            let pagosLista = this.state.pagosLista;
            let index  = pagosLista.findIndex(pago=>pago.id == id);
            pagosLista[index].fechaPago = fechasCadena;
            pagosLista[index].fechadayJs = fechasArreglo;
            let pago = Object.assign({}, pagosLista[index]);
            //pago.fechaPago = new moment(pago.fechaPago).format('DD/MM/YYYY');
            pago.fechaPago = dayjs(pago.fechadayJs).format('DD/MM/YYYY');
            this.props.pagosActions.saveFecha(pago, this.props.user).then(() => {
                    toastr.success("Fecha cambiada correctamente");
                });
            
            
            
        }else{
            let inscripcion = this.state.inscripcion;
            //inscripcion.fechaInicio = fechasArreglo;
            inscripcion.fechaInicio = fechasCadena
            inscripcion.fechadayJs = fechasArreglo;
                 //new moment(fechasCadena).format("MM-DD-YYYY");
                 //this.state.nuevo.fechaInicioExamen[0].format("DD-MM-YYYY");
            this.setState({inscripcion:inscripcion});
        }    
    }
 
    
    
    onChangePago=(event, data, id)=>{

        let pagos = this.state.pagosLista;
        let index  = pagos.findIndex(pago=>pago.id == id);
        pagos[index].referencia = data.value;
        
    }
    
    

    handleChange=(event, data)=> {

        let inscripcion = this.state.inscripcion;
        let field= data.name;		
        let value;
        
        if(field=="busqueda"){
        
            this.setState({busqueda:data.value});
            
        }else{
                if(data.type == 'radio'){
                    value=	data.checked;		
                }else{
                    value=	data.value;		
                }

                if(data.toggle){
                    if(data.checked){
                        value = 1;
                    }else{
                         value = 2
                    }
                }

                if(field=="descuento"){
                    
                    inscripcion.costoTotal = inscripcion.costoCurso*((100-data.value)/100); 
                    
                }
            
                if(field=="idTipoMoneda"){
                    
                    
                    let cursoMoneda = this.props.cursotipomonedaCombo;
                    let index  = cursoMoneda.findIndex(moneda=>moneda.id == data.value);
                    //console.log(cursoMoneda[index].valor);
                    inscripcion.costoTotal=cursoMoneda[index].valor;
                    inscripcion.costoCurso=cursoMoneda[index].valor;
                    if(inscripcion.descuento>0){
                        inscripcion.costoTotal=cursoMoneda[index].valor*((100-inscripcion.descuento)/100);
                    }
                    
                    
                }
            
            
                if(field=="idCurso"){
                    
                    this.props.inscripcionActions.getInscripcionPagoList(data.value, this.props.user).then( inscripcion=>{
                       this.setState({"inscripcionLista":inscripcion.inscripcion});
                    })
                    .catch(error=>{
                      toastr.error(error);
                    }); 
                    
                    this.props.cursotipomonedaActions.getCursoTipoMonedaCombo(data.value, this.props.user).then( cursoMoneda=>{

                    })
                    .catch(error=>{
                      toastr.error(error);
                    });
                    
                }
            

                field=field.split('.');
                if(field.length==1)
                    inscripcion[field[0]]= value;
                else{
                     if(!inscripcion[field[0]]){
                            inscripcion[field[0]]={}
                        }
                    inscripcion[field[0]][field[1]]= value;
                }

                this.setState({"inscripcion": inscripcion});
        }    
    }
    
    
    
    
    handleChangeFiltro=(event, data)=> {
        
        this.setState({"filtro": data.value});
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let inscripcion=this.state.inscripcion;
              
        if(!validations.requerido(inscripcion.idUsaurio)){
            errors.idUsaurio=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(inscripcion.idCurso)){
            errors.idCurso=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(inscripcion.idEstatus)){
            errors.estatusId=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(inscripcion.idTipoPago)){
            errors.idTipoPago=true;
            formIsValid=false;
        }
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }


    onBuscar=()=>{
        
        let cursoId = this.state.inscripcion.idCurso;
        
        this.props.usuarioActions.getUsuarioBusqueda(this.state.busqueda,cursoId, this.props.user).then((usuarioIns)=>{
            
            this.state.inscripcion.idUsaurio = usuarioIns.id;
            
           
            
            this.setState({usuario:usuarioIns});
            if(usuarioIns.inscripcionUI!=null){
                
                if(usuarioIns.fechaInicio!=null){
                        usuarioIns.fechaInicio= new moment(usuarioIns.fechaInicio).format('DD/MM/YYYY');    
                }else{
                        usuarioIns.fechaInicio= new moment().format('DD/MM/YYYY'); 
                }
                
                
                this.setState({inscripcion:usuarioIns.inscripcionUI});
            }else{
                
                
                let inscripcion = this.state.inscripcion;
                inscripcion.costoCurso = usuarioIns.cursoUI.costo;
                inscripcion.costoTotal = usuarioIns.cursoUI.costo;
                inscripcion.fechaInicio= new moment().format('DD/MM/YYYY');
                this.setState({inscripcion:inscripcion});
                
            }
            
        }) 
            .catch(error=>{ 
              toastr.error(error); 
        });
        
    }
    
    showModal=(id)=>{
        
        
        if(id>0){

            this.props.pagosActions.getPagos(id, this.props.user).then((pagos)=>{
                this.setState({pagosLista:pagos});
    
            
        }) 
            .catch(error=>{ 
              toastr.error(error); 
        });
            
            
        }
        
    
        this.setState({showModalPagos:!this.state.showModalPagos, inscripcionId:id});
        
        
    }
    
    
    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
        let newState=Object.assign({}, this.state.inscripcion);
        
        /*
        if(moment.isMoment(newState.fechaInicio)){
            newState.fechaInicio = new moment(newState.fechaInicio).format('DD/MM/YYYY');
        }else{
            newState.fechaInicio = moment(newState.fechaInicio, 'DD/MM/YYYY'); 
            newState.fechaInicio = new moment(newState.fechaInicio).format('DD/MM/YYYY');
        }
        */
        
        newState.fechaInicio = dayjs(newState.fechadayJs).format('DD/MM/YYYY');
        
        this.props.inscripcionActions.save(newState, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
            
             this.props.inscripcionActions.getInscripcionPagoList(newState.idCurso, this.props.user).then( inscripcion=>{
                       this.setState({"inscripcionLista":inscripcion.inscripcion});
                    })
                    .catch(error=>{
                      toastr.error(error);
                    }); 
            
        });
        
    }
    
    
    ReferenciaIsValid(pago){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        if(!validations.requerido(pago.referencia)){
            errors.referencia=true;
            formIsValid=false;
        }
    
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }
    
    
    pagoSave=(event, id)=>{
     
        let pagos = this.state.pagosLista;
        let index  = pagos.findIndex(pago=>pago.id == id);
        let pago = Object.assign({}, pagos[index]);
        
        pago.pagado = 1;
        
        
        event.preventDefault();
        if(!this.ReferenciaIsValid(pago)){
            pagos[index].error= true;
            return ;
        }
        
        
         this.props.pagosActions.save(pago, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
            pagos[index].pagado= 1;
            this.setState({pagosLista:pagos});
           
        });
        
    }

    
     download=()=> {
       let filtro = this.state.filtro;
       let inscripcionLista = Object.assign([], this.state.inscripcionLista);
         
         //console.log(this.state.inscripcionLista);
         //console.log(inscripcionLista);
        
        
        if(filtro!=""){
             inscripcionLista  = inscripcionLista.filter(ins => ins.empresa!=null &&  ins.empresa.toUpperCase().search(filtro.toUpperCase())>=0 ||  ins.usuario.toUpperCase().search(filtro.toUpperCase())>=0 ||  ins.mail.toUpperCase().search(filtro.toUpperCase())>=0 ||  ins.estatus.toUpperCase().search(filtro.toUpperCase())>=0 );
            
        }
         
        
        
        var headers = {
            alumno:this.state.strings["alumno"],
            mail:this.state.strings["mail"],
            pais:this.state.strings["pais"],
            empresa: this.state.strings["empresa"],
            telefono: this.state.strings["telefono"]
        };

         
            
            let itemsFormatted=[];
            

            inscripcionLista.forEach((item) => {
            
                let resultados=[];  
                 
                
                
                var element = {};
                
                if(item.pais==null){ item.pais="sin dato" }
                if(item.empresa==null){ item.empresa="sin dato" }
                

                
                element['alumno'] = item.usuario;
                element['mail'] = item.mail;
                element['pais'] = item.pais;
                element['empresa'] = "\""+item.empresa+ "\"";
                element['telefono'] = item.telefono;
                
                  
                itemsFormatted.push(element);
                
                
            });

            var fileTitle = 'Reporte alumnos para pagar'; // or 'my-unique-title'
            exportCSVFile(headers, itemsFormatted, fileTitle); // call the exportCSVFile() function to process the JSON and trigger the download
   
        
    }
       
    render() {	
        
        let filtro = this.state.filtro;
        let inscripcionLista = Object.assign([], this.state.inscripcionLista);
        
        if(filtro!=""){
             inscripcionLista  = inscripcionLista.filter(ins => ins.empresa!=null &&  ins.empresa.toUpperCase().search(filtro.toUpperCase())>=0 ||  ins.usuario.toUpperCase().search(filtro.toUpperCase())>=0 ||  ins.mail.toUpperCase().search(filtro.toUpperCase())>=0 ||  ins.estatus.toUpperCase().search(filtro.toUpperCase())>=0 );
            
        }
        
          
        let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 		return (
              <Segment  style={margenes}>
                <Panel 
                    ventaInvMf={this.state.ventaInvMf}
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    onChangeFiltro={this.handleChangeFiltro}
                    errors={this.state.errors}
                    datos={this.state.inscripcion}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    cursoCombo={genericFormattedForDropdown(this.props.cursoCombo)}
                    onBuscar={this.onBuscar}
                    usuario={this.state.usuario}
                    estatusCombo={genericFormattedForDropdown(this.state.estatusCombo)}
                    tipoPagoCombo={genericFormattedForDropdown(this.state.tipoPagoCombo)}
                    usuarioCombo={genericFormattedForDropdown(this.props.usuarioCombo)}
                    tipomonedaCombo={genericFormattedForDropdown(this.props.tipomonedaCombo)}
                    cursotipomonedaCombo={genericFormattedForDropdown(this.props.cursotipomonedaCombo)}
                    onSave={this.onSave}
                    busqueda={this.state.busqueda}
                    inscripcionLista={inscripcionLista}
                    pagos={this.showModal}
                    fechas={this.fechas}
                    download={this.download}
                />
                
                <ModalPagos
                    showModal={this.state.showModalPagos}
                    closeModal={this.showModal}
                    strings={this.props.strings}
                    pagosLista={this.state.pagosLista}
                    onChange={this.onChangePago} 
                    pagoSave={this.pagoSave}
                    fechas={this.fechas}
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    
        
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda, 
        color:state.color,
        user:state.user, 
        idioma:state.idioma,
        strings:state.strings, 
        form:state.form,
        cursoCombo:state.cursoCombo,
        usuarioCombo:state.usuarioCombo,
        tipomonedaCombo:state.tipomonedaCombo,
        cursotipomonedaCombo:state.cursotipomonedaCombo
    }

}

function mapDispatchToProps(dispatch){

	return {   
            showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
            paginaActions: bindActionCreators(paginaActions, dispatch),
            cursoActions: bindActionCreators(cursoActions, dispatch),
            usuarioActions: bindActionCreators(usuarioActions, dispatch),
            inscripcionActions: bindActionCreators(inscripcionActions, dispatch),
            pagosActions: bindActionCreators(pagosActions, dispatch),
            tipomonedaActions: bindActionCreators(tipomonedaActions, dispatch),
            cursotipomonedaActions:bindActionCreators(cursotipomonedaActions, dispatch),
            userActions: bindActionCreators(userActions, dispatch),
	};
}

function Parametros(){
    const {id} = useParams();
    const location = useLocation();
    return{
        id
    }
}


export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManageInscripcionForm));